import * as Sentry from "@sentry/browser";

const LOCAL_ENV = "localhost";

/**
 * get the domain of the environment like :
 * http://localhost:7093 -> localhost
 *
 * @return {[type]} [description]
 */
function getEnvironment() {
	return window.location.href.match("^(?:https?://)([^:/?\n]+)")[1];
}

/**
 * Function that let us to initialize all the
 * libraries usefull for the app.
 */
function initialize() {
	const environment = getEnvironment();

	if (environment !== LOCAL_ENV) {
		// Side part for Sentry
		Sentry.init({
			dsn: "https://ec109679ba0a4221becfbc05a2d8308f@sentry.io/1892221",
			release: process.env.REACT_APP_RELEASE,
			ignoreErrors: ["ResizeObserver"],
			environment
		});
	}
}

export { getEnvironment };

export default initialize;
